import React from "react";
import {
  Box,
  SimpleGrid,
  HStack,
  VStack,
  Text,
  IconButton,
} from "@chakra-ui/react";
import { ChevronUpIcon, ChevronDownIcon } from "@chakra-ui/icons";
import { usdt } from "../../config";

const PositionsGrid = ({
  positionsDetails,
  collateralTokens,
  indexTokens,
  prices,
  tokenImages,
  link,
  usdc,
  usdc_e,
  weth,
  wbtc,
  btc,
  showDetails,
  toggleDetails,
  formatAddress,
  sellLimit,
  _lossLimit,
  totalPositions,
  totalCollateral,
  utilizationRate,
  usdcBalance,
  handleReload,
  tokenName,
}) => {
  return (
    <SimpleGrid
      columns={{ base: 2, sm: 2, md: 2 }} // Ensure 2 columns on mobile
      spacing={4} // Spacing between cards
      mt={2}
    >
      {positionsDetails.map((position) => {
        const collateralTokenName =
          collateralTokens[position.positionIndex] === link
            ? "link"
            : collateralTokens[position.positionIndex] === usdc
            ? "usdc"
            : collateralTokens[position.positionIndex] === usdt
            ? "usdt"
            : collateralTokens[position.positionIndex] === usdc_e
            ? "usdc.e"
            : collateralTokens[position.positionIndex] === weth
            ? "weth"
            : collateralTokens[position.positionIndex] === wbtc
            ? "wbtc"
            : collateralTokens[position.positionIndex] === btc
            ? "btc"
            : "unknown";

        const indexTokenName =
          indexTokens[position.positionIndex] === link
            ? "link"
            : indexTokens[position.positionIndex] === usdc
            ? "usdc"
            : indexTokens[position.positionIndex] === weth
            ? "weth"
            : indexTokens[position.positionIndex] === wbtc
            ? "wbtc"
            : indexTokens[position.positionIndex] === btc  // Corrected here
            ? "btc"
            : "unknown";

        

        const tokenImage1 = tokenImages[collateralTokenName] || "./usdt.png";
        const tokenImage2 = tokenImages[indexTokenName] || "./eth.png";

        const collateralTokenDisplayName =
          collateralTokenName === "usdc_e"
            ? "USDC.e"
            : collateralTokenName.toUpperCase();
        const indexTokenDisplayName =
          indexTokenName === "usdc" ? "USDC.e" : indexTokenName.toUpperCase();

        const positionType = position.isLong ? "Long" : "Short"; // Determine position type

        return (
          <Box p={4} w="auto" h='100%' justifyItems="center" key={position.positionIndex}>
            <Box
              w="125px"
              p={1}
              fontSize='sm'
              fontFamily='Sentinel-light'
              bg="white"
              shadow='dark-lg'
              borderWidth="1px"
              borderRadius="md"
            >
              
              <HStack gap="2px" p={0}  justify='center'>
                
                <Text
                  fontFamily='Sentinel'
                  textAlign="center"
                  color={position.hasProfit === "1" ? "green.500" : "red.500"}
                >
                  {position.deltaPercentage}
                </Text>
                <Text
                  fontFamily='Sentinel'
                  textAlign="center"
                  color={position.hasProfit === "1" ? "green.500" : "red.500"}
                >
                  (${position.delta})
                </Text>
              </HStack>

              
              <HStack gap="2px" mt={1}>
                {/**<img
                  src={tokenImage1}
                  alt={collateralTokenName}
                  style={{ width: "11px", marginRight: "0px" }}
                />
                <Text>/</Text> */}
                <img
                  src={tokenImage2}
                  alt={indexTokenName}
                  style={{
                    width: "25px",
                    marginLeft: "0px",
                    marginRight: "1px",
                  }}
                />
                <Text fontFamily='Sentinel' >{indexTokenDisplayName}</Text>

                
              </HStack>
              
              
              <Text>
                Type: {positionType}
                
              </Text>
                <Text>Size: ${position.size}</Text>
                <Text>Collateral: ${position.collateral}</Text>
              

              {/* Toggle Details Button */}
              <HStack justify="center">
                <IconButton
                  icon={showDetails ? <ChevronUpIcon /> : <ChevronDownIcon />}
                  onClick={toggleDetails}
                  aria-label="Toggle Position Details"
                  size="sm"
                  variant="unstyled"
                />
              </HStack>

              {/* Position Details (conditionally rendered) */}
              {showDetails && (
                <Box  >
                  <HStack gap='2px'>
                    <Text as='b'>
                       {collateralTokenDisplayName}/{indexTokenDisplayName}
                    </Text>
                  </HStack>

                  <Text>Leverage: {position.leverage}x</Text>
                  <Text  >
                  Price: ${prices[position.positionIndex]}
                </Text>
                  <Text>Entry: {position.entryPrice}</Text>
                  <Text>Sell Limit: {sellLimit} %</Text>
                  <Text>Loss Limit: {_lossLimit} %</Text>
                  <Text>Sell: ${position.sellPrice}</Text>
                  <Text>Buy: ${position.buyPrice}</Text>
                  <Text>Fees: {position.openClose}</Text>
                  <Text>Profit/Risk: ${position.potential}</Text>
                  <Text fontSize='xs'>Last: {position.lastIncreasedTime}</Text>
                </Box>
              )}
            </Box>
          </Box>
        );
      })}
    </SimpleGrid>
  );
};

export default PositionsGrid;
